import { createLazyFileRoute } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { ErrorPage } from "@/components/ErrorPage";
import { LoadingPage } from "@/components/LoadingPage";
import {
  NoTestOrderError,
  TestRunWorkspace,
} from "@/features/runs/components/TestRunWorkspace";

export const Route = createLazyFileRoute("/_auth/_app/runs/$id/workspace")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const testRun = trpc.runs.get.useQuery({ id });

  const { data, error, isPending, isError } =
    trpc.process.getByTestRunId.useQuery(
      {
        testRunId: id,
      },
      {
        retry(failureCount, error) {
          if (
            error.data?.code === "CONFLICT" ||
            error.data?.code === "NOT_FOUND"
          ) {
            return false;
          }
          return true;
        },
      },
    );

  if (isPending || testRun.isPending) {
    return <LoadingPage />;
  }

  if (testRun.isError) {
    return <ErrorPage error={testRun.error} />;
  }

  if (isError) {
    if (error.message.includes("at least one associated test order")) {
      return <NoTestOrderError testRun={testRun.data} />;
    }
    return <ErrorPage error={error} />;
  }

  return <TestRunWorkspace workspace={data} testRun={testRun.data} />;
}
